<template>
  <div>
    <Header
      class="yh-header"
      active="/product"
      show-sub
      :sub-menu="subMenu"
      :product-value="productValue"
    >
      <template #left>
        <ImageAndName
          :image="util.getImageUrl(util.getHead(util.string2Array(get.images)), '48x48')"
          :name="get.name"
          :code="get.code"
        />
      </template>
      <template #right>
        <Feedback
          target-name="供应链信息"
          :target-id="$route.params.id"
        />
        <Favourite
          target-name="product"
          :target-id="$route.params.id"
          :purchase-level="0"
        />
      </template>
    </Header>
    <div style="height: 130px" />
    <SupplyChianCommodity
      class="yh-main"
      @query="onCommodityQuery"
    />
    <SupplyChainSupplierRanking
      class="yh-main"
      @change="onSupplierPageChange"
    />
    <SupplyChainProvince
      v-if="get.code"
      class="yh-main"
      :code="get.code"
      @select="onProvinceSelect"
      @change="onProvincePageChange"
    />
    <SupplyChainProvinceSalesRanking
      class="yh-main"
      @query="onSaleProvinceQuery"
    />
    <SupplyChainShopSalesRanking
      class="yh-main"
      @query="onSaleShopQuery"
    />
    <div style="min-height: 70px" />
  </div>
</template>

<script>
import Header from '@/components/Header'
import SupplyChianCommodity from '@/components/SupplyChianCommodity'
import SupplyChainSupplierRanking from '@/components/SupplyChainSupplierRanking'
import SupplyChainProvince from '@/components/SupplyChainProvince'
import SupplyChainProvinceSupplierRanking from '@/components/SupplyChainProvinceSupplierRanking'
import SupplyChainProvinceSalesRanking from '@/components/SupplyChainProvinceSalesRanking'
import SupplyChainShopSalesRanking from '@/components/SupplyChainShopSalesRanking'

import Favourite from '@/components/Favourite.vue'
import Feedback from '@/components/Feedback'
import ImageAndName from '@/components/ImageAndName.vue'

export default {
  name: 'ProductChain',
  components: {
    Header,
    Favourite,
    ImageAndName,
    Feedback,
    /**
     * 基础信息
     */
    SupplyChianCommodity,
    /**
     * 全国供应商排名
     */
    SupplyChainSupplierRanking,
    /**
     * 十大战区二十四省区
     */
    SupplyChainProvince,
    /**
     * 省区供应商排名
     */
    SupplyChainProvinceSupplierRanking,
    /**
     * 省区销售排名
     */
    SupplyChainProvinceSalesRanking,
    /**
     * 门店销售排名
     */
    SupplyChainShopSalesRanking
  },
  data() {
    const curDate = new Date()
    const preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000)
    return {
      curDate,
      preDate,
      subMenu: [
        {
          name: '商品百科',
          path: `/product/baike/${this.$route.params.id}`,
          active: false
        },
        {
          name: '供应链信息',
          path: `/product/chain/${this.$route.params.id}`,
          active: true
        },
        {
          name: '数据看板',
          path: `/product/dashboard/${this.$route.params.id}`,
          active: false
        }
      ],
      productValue: this.util.getVariantSession('tagId')
    }
  },
  computed: {
    get() {
      return this.$store.state.product.productBase.get
    }
  },
  async created() {
    // 获取商品信息
    await this.$store.dispatch('productBasePage', {
      packageName: 'product',
      className: 'productBase',
      methodName: 'get',
      params: {
        id: this.$route.params.id
      }
    })
    // 获取商品销售数据
    this.$store.dispatch('scSaleCommodityData', {
      packageName: 'sc',
      className: 'scSaleCommodity',
      methodName: 'retrieve',
      params: {
        code: this.get.code,

        orderField: 'saleDate',
        orderDirection: 'desc',

        numPerPage: 1
      }
    })
    // 获取全国前80%进货额供应商数据
    this.$store.dispatch('scSupplierAllData', {
      packageName: 'sc',
      className: 'scSupplierAll',
      methodName: 'latest',
      params: {
        commodityCode: this.get.code,
        numPerPage: 10
      }
    })
    // // 获取省区销售数据
    // this.$store.dispatch("scSaleProvinceData", {
    //   packageName: "sc",
    //   className: "scSaleProvince",
    //   methodName: "latest",
    //   params: {
    //     code: this.get.code,
    //     numPerPage: 10
    //   }
    // });
    // // 获取门店销售数据
    // this.$store.dispatch("scSaleShopData", {
    //   packageName: "sc",
    //   className: "scSaleShop",
    //   methodName: "latest",
    //   params: {
    //     code: this.get.code,
    //     numPerPage: 10
    //   }
    // });

    this.ajax.doPost({
      packageName: 'user',
      className: 'userAnalysis',
      methodName: 'create',
      params: {
        userId: this.$store.state.sys.sysUser.me.id,
        moduleName: '商品百科-供应链信息',
        moduleResourceId: this.$route.params.id,
        path: this.$route.path
      }
    })

    // 获取更新时间
    this.onGetSyncTime('scSaleCommodity') // 全国销售信息
    this.onGetSyncTime('scSupplierAll') // 全国供应商信息
    this.onGetSyncTime('scSaleProvince') // 省区销售龙虎榜
    this.onGetSyncTime('scSaleShop') // 门店销售龙虎榜
  },
  methods: {
    onSupplierPageChange(e) {
      this.$store.dispatch('scSupplierAllData', {
        packageName: 'sc',
        className: 'scSupplierAll',
        methodName: 'latest',
        params: {
          commodityCode: this.get.code,

          pageNum: e,
          numPerPage: 10
        }
      })
    },
    onProvinceSelect(zone, prov) {
      // 获取省区供应商数据
      this.$store.dispatch('scSupplierProvinceData', {
        packageName: 'sc',
        className: 'scSupplierProvince',
        methodName: 'latest',
        params: {
          commodityCode: this.get.code,
          zone,
          province: prov,
          numPerPage: 10
        }
      })
    },
    onProvincePageChange(zone, prov, e) {
      this.$store.dispatch('scSupplierProvinceData', {
        packageName: 'sc',
        className: 'scSupplierProvince',
        methodName: 'latest',
        params: {
          commodityCode: this.get.code,
          zone,
          province: prov,
          numPerPage: 10,

          pageNum: e
        }
      })
    },
    onCommodityQuery(e) {
      this.$store.dispatch('scSaleCommodityData', {
        packageName: 'sc',
        className: 'scSaleCommodity',
        methodName: 'retrieve',
        params: {
          code: this.get.code,
          saleDate: e,

          orderField: 'saleDate',
          orderDirection: 'desc',

          numPerPage: 10
        }
      })
    },
    onSaleProvinceQuery(e) {
      console.log(e)
      this.$store.dispatch('scSaleProvinceData', {
        packageName: 'sc',
        className: 'scSaleProvince',
        methodName: 'ranking',
        params: {
          code: this.get.code,
          orderField: 'amount',
          orderDirection: 'desc',
          numPerPage: 10,
          saleDateBegin: e.startDate,
          saleDateEnd: e.endDate
          // saleDate: e
        }
      })
    },
    onSaleShopQuery(e) {
      this.$store.dispatch('scSaleShopData', {
        packageName: 'sc',
        className: 'scSaleShop',
        methodName: 'ranking',
        params: {
          code: this.get.code,
          // saleDate: e,
          orderField: 'amount',
          orderDirection: 'desc',
          numPerPage: 10,
          saleDateBegin: e.startDate,
          saleDateEnd: e.endDate
        }
      })
    },
    onGetSyncTime(className) {
      this.$store.dispatch('scSupplierTimeData', {
        packageName: 'sc',
        className,
        methodName: 'getSyncTime',
        params: {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
.el-header {
  box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.06);
}
.container {
  width: 1140px;
  margin: 5px auto;
}
.el-main {
  padding-top: 0;
}
.el-breadcrumb {
  width: 1100px;
  margin: 0 auto;
  padding: 20px 0;
  border-bottom: 1px solid #eee;
}
</style>
